import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'projectName',
    label: 'Project Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'projectStatusType',
    label: 'Project Status Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'projectClassification',
    label: 'Project Classification',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'cpmProjectId',
    label: 'CPM Project ID# (if any)',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'projectUnitsNumber',
    label: 'Number of Units (Project)',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'projectSoldUnitsNumber',
    label: 'Number of Units Sold',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'estimatedRemainingLife',
    label: 'Estimated Remaining Life (Years)',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'associationFeesName',
    label: 'Association Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'associationFeesEmail',
    label: 'Association Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'associationFeesPhoneNumber',
    label: 'Association Phone',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'condominiumCooperativePhase',
    label: 'Condominium/Cooperative Phase',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'condominiumCooperativeSpotLot',
    label: 'Spot Lot',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const projectForm = {
  name: FormNames.PROJECT,
  label: 'Project',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
